// SPDX-License-Identifier: AGPL-3.0-only
/**
 * CrudApi — the typed data-access adapter the `page-crud` template receives
 * as a prop. The template never fetches; the dashboard interpreter
 * implements this against the generated CRUD API
 * (apps/server/src/routes/data) and hands it in:
 *
 * list GET /api/v1/data/:connectionId/:table get GET
 *   /api/v1/data/:connectionId/:table/:recordId(?include=inboundCounts) create POST
 *   /api/v1/data/:connectionId/:table update PATCH
 *   /api/v1/data/:connectionId/:table/:recordId remove DELETE
 *   /api/v1/data/:connectionId/:table/:recordId(?dryRun|confirm) references GET
 *   /api/v1/data/:connectionId/:table/:recordId/references bulk POST
 *   /api/v1/data/:connectionId/:table/bulk undo POST /api/v1/data/undo/:token lookup GET
 *   list on the FK's referenced table (q= on display column) listRelated GET list on a
 *   referencing table (where column = value) export POST /api/v1/exports (a queued
 *   export-run job)
 *
 * Every shape below mirrors apps/server/src/routes/data/schema.ts verbatim
 * so the dashboard implementation is a straight `fetch` + JSON pass-through.
 */
/** Filter grammar (apps/server/src/crud/filters.ts). */
export const CRUD_FILTER_OPS = [
    'eq',
    'neq',
    'gt',
    'gte',
    'lt',
    'lte',
    'in',
    'like',
    'ilike',
    'is_null',
    'not_null',
    'between',
];
export function isDeletePreview(result) {
    return typeof result === 'object' && result !== null && 'references' in result && !('data' in result);
}
//# sourceMappingURL=crud-api.js.map